// extracted by mini-css-extract-plugin
var _1 = "Modal_closeButton__t-o1y";
var _2 = "Modal_modal__1eH6B";
var _3 = "Modal_modalOverlay__jXIds";
export { _1 as "closeButton", _2 as "modal", _3 as "modalOverlay" }
